import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { IconButton } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'

type IOpenConversationActionProps = {
  onClick: () => void
}

export const OpenConversationAction: FC<IOpenConversationActionProps> = observer(({ onClick }) => {
  const { conversationStore } = useEntitiesContext()
  const loading = conversationStore.conversationOpenStore.loading

  return (
    <IconButton
      icon={'linkExternalLine'}
      color={'secondary'}
      variant={'icon'}
      ariaLabel='LinkExternal'
      disabled={loading}
      onClick={onClick}
      tooltipProps={{
        label: 'Open in Conversations',
        placement: 'top',
      }}
    />
  )
})
